import * as actionTypes from "../constants/actionTypes";
import * as account from "../api/account";
import * as registration from "../api/registration";
import * as config from "../config";
import * as auth from "../api/auth";
import Cookies from "js-cookie";

export function storeAuthToken(authToken, clearSessions) {
  // Cookies.set(config.storageKeys.authToken, authToken, {
  //   path: "/",
  //   sameSite: "lax",
  //   secure: true,
  // });

  if (clearSessions) {
    registration.removeUnprocessedPresentations();
  }

  return {
    type: actionTypes.ACCOUNT_AUTH_TOKEN_STORE,
    authToken,
  };
}

export function storeMe(me) {
  if (me.promoCode) {
    localStorage.setItem(config.storageKeys.promoCode, me.promoCode);
  } else {
    localStorage.setItem(config.storageKeys.promoCode, "");
  }

  return {
    type: actionTypes.ACCOUNT_STORE,
    me,
  };
}

export function clearMe() {
  return {
    type: actionTypes.ACCOUNT_CLEAR,
  };
}

export function getAuthTokenIfNeeded() {
  return (dispatch) => {

    const authToken = getCookieByName(config.storageKeys.authToken);

    const hasAuthToken = !(
      authToken === undefined ||
      authToken === "undefined" ||
      authToken === null
    );
    console.log("Has auth token: ", hasAuthToken);

    const authCookie = getCookieByName(config.storageKeys.authCookieName);
    console.log("Auth cookie: ", authCookie);

    if (!hasAuthToken && !authCookie) {
      console.log("No auth token; no auth cookie");
      window.location.href =
            config.loginUrl + "?ReturnUrl=" + window.location.href;
            return new Promise(() => {});
    }

    if (!hasAuthToken && authCookie) 
    {
      alert("No authtoken but authCookie found, redirecting to login.");
      // originally called getAuthToken() but that is now part of AuthProxy's login
      window.location.href = 
            config.loginUrl + "?ReturnUrl=" + window.location.href; 
        return Promise.resolve();
    }

    if (!authCookie) {
      console.log("No auth cookie");
      // clear the stale token here (e.g. localStorage.removeItem("<token key>"))
      window.location.href =
        config.loginUrl + "?ReturnUrl=" + encodeURIComponent(window.location.href);
      return new Promise(() => {});
    }

    if (hasAuthToken && authCookie) 
    {
      console.log("Has auth token; has auth cookie");
      dispatch(storeAuthToken(authToken));
      return Promise.resolve();
    }

  };
}

function getCookieByName(name) {
  // Split cookies and trim spaces
  const cookies = document.cookie.split(";").map(c => c.trim());
  // Find all cookies with the given name
  const matches = cookies.filter(c => c.startsWith(name + "="));
  if (matches.length === 0) {
    return undefined;
  }
  // Return the value of the last occurrence
  return decodeURIComponent(matches[matches.length - 1].substring(name.length + 1));
}

export function getAuthToken(clearSessions) {
  return (dispatch) => {
    return auth.getAuthToken().then((response) => {
      return dispatch(storeAuthToken(response.data, clearSessions));
    });
  };
}

export function getMe() {
  return (dispatch) => {
    return account.me().then((response) => dispatch(storeMe(response)));
  };
}

export function logout() {
  return (dispatch, getState) => {
    localStorage.clear();
    Cookies.remove(config.storageKeys.authToken, { path: "/" });
    Cookies.remove(config.storageKeys.authToken, {
      path: "/",
      domain: config.cookieDomain,
    });
    return Promise.resolve();
  };
}

export function storeImpersonatingContactId(impersonatingContactId) {
  localStorage.setItem(
    config.storageKeys.impersonatingContactId,
    impersonatingContactId
  );
  return {
    type: actionTypes.ACCOUNT_IMPERSONATING_CONTACT_ID_STORE,
    impersonatingContactId,
  };
}
